import PeopleSelectDefaultValueConfig from './editors/people-select-default-value-config'
import DepartmentSelectDefaultValueConfig from './editors/department-select-default-value-config'
import StaticImgDefaultValueConfig from './editors/static-img-default-value-config'
import CalcRuleConfig from './editors/calc-rule-config'
import AssociatedSelectFormConfig from './editors/associated-select-form-config'
import AssociatedSelectCurrentCodesConfig from './editors/associated-select-current-codes-config'
import AssociatedSelectComponentConfig from './editors/associated-select-component-config'
import LovDataSelectorConfig from './editors/lov-data-selector-config'
import AreaDefaultValueConfig from './editors/area-default-value-config'
import DataSourceConfig from './editors/data-source-config'
import OrcSelectorConfig from './editors/orc-selector-config'
import OrcTypeConfig from './editors/orc-type-config'
import PeopleSelectDataSourceConfig from './editors/people-select-data-source-config'
import DeptSelectDataSourceConfig from './editors/department-select-data-source-config'

const EditorConfig = [
  {
    editorConfigType: 'INFO',
    componentName: 'FormConfigInfo'
  },
  {
    editorConfigType: 'LABEL',
    componentName: 'FormConfigLabel',
    configProperty: 'label',
    allowProperties: ['label', 'defaultValue']
  },
  {
    editorConfigType: 'PLACEHOLDER',
    componentName: 'FormConfigPlaceholder',
    configProperty: 'placeholder'
  },
  {
    editorConfigType: 'MAXLENGTH',
    componentName: 'FormConfigMaxlength',
    configProperty: 'lengthLimit'
  },
  {
    editorConfigType: 'INPUT_DEFAULT',
    componentName: 'FormConfigInputDefault',
    configProperty: 'defaultValue'
  },
  {
    editorConfigType: 'TEXTAREA_DEFAULT',
    componentName: 'FormConfigTextareaDefault',
    configProperty: 'defaultValue'
  },
  {
    editorConfigType: 'WIDTH',
    componentName: 'FormConfigWidth',
    configProperty: 'width'
  },
  {
    editorConfigType: 'HIDDEN',
    componentName: 'FormConfigHidden',
    configProperty: 'hidden'
  },
  {
    editorConfigType: 'READONLY',
    componentName: 'FormConfigReadonly',
    configProperty: 'readOnly'
  },
  {
    editorConfigType: 'REQUIRED',
    componentName: 'FormConfigRequired',
    configProperty: 'required'
  },
  {
    editorConfigType: 'EDITONNEW',
    componentName: 'FormConfigEditonnew',
    configProperty: 'onlyCreateEdit'
  },
  {
    editorConfigType: 'UNIQUE',
    componentName: 'FormConfigUnique',
    configProperty: 'uniqueCheck'
  },
  {
    editorConfigType: 'DATEDISPLAYTYPE',
    componentName: 'FormConfigDateDisplay',
    configProperty: 'dateDisplayStyle'
  },
  {
    editorConfigType: 'DATEDEFAULTVALUE',
    componentName: 'FormConfigDateDefault',
    configProperty: 'defaultValue'
  },
  {
    editorConfigType: 'NUMBER_RANGE',
    componentName: 'FormConfigNumberRange',
    configProperty: 'numberMin',
    allowProperties: ['numberMin', 'numberMax']
  },
  {
    editorConfigType: 'NUMBER_PRECISION',
    componentName: 'FormConfigNumberPrecision',
    configProperty: 'decimalNum'
  },
  {
    editorConfigType: 'NUMBER_DEFAULT',
    componentName: 'FormConfigNumberDefault',
    configProperty: 'defaultValue'
  },
  {
    editorConfigType: 'MONEY_DISPALY',
    componentName: 'FormConfigMoneyDisplay',
    configProperty: 'moneyDisplayStyle'
  },
  {
    editorConfigType: 'MONEY_DEFAULT',
    componentName: 'FormConfigMoneyDefault',
    configProperty: 'defaultValue'
  },
  {
    editorConfigType: 'DOCUMENT_NUMBER_RULE',
    componentName: 'FormConfigDocumentNumberRule',
    configProperty: 'documentNumRules'
  },
  {
    editorConfigType: 'UPLOADLIMIT',
    componentName: 'FormConfigUploadLimit',
    configProperty: 'fileMaxNum'
  },
  {
    editorConfigType: 'UPLOADSIZE',
    componentName: 'FormConfigUploadSize',
    configProperty: 'fileMaxSize'
  },
  {
    editorConfigType: 'UPLOADSHOWTYPE',
    componentName: 'FormConfigUploadType',
    configProperty: 'fileDisplayType'
  },
  {
    editorConfigType: 'UPLOADFILETYPE',
    componentName: 'FormConfigUploadFiletype',
    configProperty: 'fileType'
  },
  {
    editorConfigType: 'CHOOSETYPE',
    componentName: 'FormConfigSelectType',
    configProperty: 'chooseType'
  },
  {
    editorConfigType: 'LINECHOOSENUM',
    componentName: 'FromConfigChooseNum',
    configProperty: 'lineChooseNum'
  },
  {
    editorConfigType: 'MULTICOLOR',
    componentName: 'FormConfigSelectValuelist',
    configProperty: 'multicolor',
    allowProperties: ['multicolor', 'chooseOptions', 'selectDefaultValue']
  },
  {
    editorConfigType: 'PHONE_DEFAULT',
    componentName: 'FormConfigPhoneDefault',
    configProperty: 'defaultValue'
  },
  {
    editorConfigType: 'EMAIL_DEFAULT',
    componentName: 'FormConfigEmailDefault',
    configProperty: 'defaultValue'
  },
  {
    editorConfigType: 'IDCARD_DEFAULT',
    componentName: 'FormConfigIdCardDefault',
    configProperty: 'defaultValue'
  },
  {
    editorConfigType: 'IDCARD_TYPE',
    componentName: 'FormConfigIdCardType',
    configProperty: 'idCardType'
  },
  {
    editorConfigType: 'TEXT_COLOR',
    componentName: 'FormConfigTextColor',
    configProperty: 'textColor'
  },
  {
    editorConfigType: 'SPLIT_COLOR',
    componentName: 'FormConfigSplitColor',
    configProperty: 'textColor'
  },
  {
    editorConfigType: 'STATIC_TEXT_DEFAULT',
    componentName: 'FormConfigStatcTextDefault',
    configProperty: 'staticDefaultValue'
  },
  {
    editorConfigType: 'SPLIT_DEFAULT',
    componentName: 'FormConfigSplitDefault',
    configProperty: 'staticDefaultValue'
  },
  {
    editorConfigType: 'IMG_HEIGHT_LIMIT',
    componentName: 'FormConfigImgHeightLimit',
    configProperty: 'imgHeightLimit'
  },
  PeopleSelectDefaultValueConfig,
  DepartmentSelectDefaultValueConfig,
  StaticImgDefaultValueConfig,
  CalcRuleConfig,
  LovDataSelectorConfig,
  AssociatedSelectFormConfig,
  {
    editorConfigType: 'ASSOCIATED_SHOW_TYPE',
    componentName: 'FormConfigAssociatedDisplayType',
    configProperty: 'displayStyle'
  },
  AssociatedSelectCurrentCodesConfig,
  {
    editorConfigType: 'ASSOCIATED_ALLOW_ADD',
    componentName: 'FormConfigAssociatedAllowAdd',
    configProperty: 'assocAllowNew'
  },
  AssociatedSelectComponentConfig,
  {
    editorConfigType: 'LOV_ASSIGNMENT',
    componentName: 'FormConfigLovAssignment',
    configProperty: 'formAssignment'
  },
  {
    editorConfigType: 'ADJUST_LOCATION',
    componentName: 'FormConfigAdjustLocationConfig',
    configProperty: 'locationRange'
  },
  {
    editorConfigType: 'LOCATION_CENTER',
    componentName: 'FormConfigLocationCenterConfig',
    configProperty: 'showLocationCenter'
  },
  {
    editorConfigType: 'AREA_TYPE',
    componentName: 'FormConfigAreaTypeConfig',
    configProperty: 'areaType'
  },
  {
    editorConfigType: 'PEOPLE_SELECT_DATA_FILTER',
    componentName: 'FormConfigPeopleSelectDataFilter',
    configProperty: 'filterConditionGroupList',
    allowProperties: ['filterConditionGroupList', 'peopleOrDeptSelectFilterDisplayText']
  },
  {
    editorConfigType: 'DEPT_SELECT_DATA_FILTER',
    componentName: 'FormConfigDeptSelectDataFilter',
    configProperty: 'filterConditionGroupList',
    allowProperties: ['filterConditionGroupList', 'peopleOrDeptSelectFilterDisplayText']
  },
  {
    editorConfigType: 'HYPERLINK_DEFAULT',
    componentName: 'FormConfigHyperlinkDefault',
    configProperty: 'defaultValue'
  },
  AreaDefaultValueConfig,
  DataSourceConfig,
  OrcSelectorConfig,
  OrcTypeConfig,
  PeopleSelectDataSourceConfig,
  DeptSelectDataSourceConfig
]

export default EditorConfig
